import { doDelete, doGet, doPost, doPut } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import type {
  CreateDashboardRequest,
  DashboardDetail,
  DashboardStatus,
  DashboardSummary,
  UpdateDashboardRequest,
} from './types';

const baseUrl = (accountId: string, projectId: string) =>
  `accounts/${accountId}/projects/${projectId}/aggregated_dashboards`;

export const getAggregatedDashboards = (
  accountId: string,
  projectId: string,
) => {
  return doGet<DashboardSummary[]>(
    baseUrl(accountId, projectId),
    LOGGER_TYPE.ANALYTICS,
    { prefix: 'nebula' },
  );
};

export const getAggregatedDashboard = (
  accountId: string,
  projectId: string,
  dashboardId: string,
  view?: DashboardStatus,
) => {
  return doGet<DashboardDetail>(
    `${baseUrl(accountId, projectId)}/${dashboardId}`,
    LOGGER_TYPE.ANALYTICS,
    { prefix: 'nebula', ...(view && { params: { view } }) },
  );
};

export const createAggregatedDashboard = (
  accountId: string,
  projectId: string,
  body: CreateDashboardRequest,
) => {
  return doPost<DashboardDetail>(
    baseUrl(accountId, projectId),
    LOGGER_TYPE.ANALYTICS,
    body,
    { prefix: 'nebula' },
  );
};

export const updateAggregatedDashboard = (
  accountId: string,
  projectId: string,
  dashboardId: string,
  body: UpdateDashboardRequest,
) => {
  return doPut<DashboardDetail>(
    `${baseUrl(accountId, projectId)}/${dashboardId}`,
    LOGGER_TYPE.ANALYTICS,
    body,
    { prefix: 'nebula' },
  );
};

export const publishAggregatedDashboard = (
  accountId: string,
  projectId: string,
  dashboardId: string,
) => {
  return doPost<DashboardDetail>(
    `${baseUrl(accountId, projectId)}/${dashboardId}/publish`,
    LOGGER_TYPE.ANALYTICS,
    {},
    { prefix: 'nebula' },
  );
};

export const discardDraftAggregatedDashboard = (
  accountId: string,
  projectId: string,
  dashboardId: string,
) => {
  return doPost<DashboardDetail>(
    `${baseUrl(accountId, projectId)}/${dashboardId}/discard`,
    LOGGER_TYPE.ANALYTICS,
    {},
    { prefix: 'nebula' },
  );
};

export const deleteAggregatedDashboard = (
  accountId: string,
  projectId: string,
  dashboardId: string,
) => {
  return doDelete<void>(
    `${baseUrl(accountId, projectId)}/${dashboardId}`,
    LOGGER_TYPE.ANALYTICS,
    {},
    { prefix: 'nebula' },
  );
};
